import React, { useContext, useEffect, useState } from 'react'
import { buildUrl, extractDomain } from '../../services/urlService'
import { Link } from 'gatsby'
import LocaleContext from '../../contexts/localeContext'
import { useBlogNavigation } from '../../hooks/navigation/useBlogNavigation'
import {
  buildBrochureButtonInteractionEvent,
  publishBrochureButtonInteractionEvent,
} from '../../services/dataLayerService'
import { findParentElementA } from '../../services/domService'
import DataLayerContext from '../../contexts/dataLayerContext'

const CTA = ({ ctaObject, suppressTopMargin }) => {
  const { eventApi } = useContext(DataLayerContext)
  const locale = useContext(LocaleContext)
  const [link1Url, setLink1Url] = useState()
  const [link2Url, setLink2Url] = useState()
  const [blogBaseUrl] = useState(buildUrl(useBlogNavigation(locale), ''))
  const [eventModelToPublish, setEventModelToPublish] = useState()

  useEffect(() => {
    if (ctaObject.link1 && ctaObject.link1.internal.type === 'ContentfulBlog') {
      setLink1Url(blogBaseUrl + '/' + ctaObject.link1.slug)
    } else if (ctaObject.link1) {
      setLink1Url(buildUrl(ctaObject.link1, ''))
    }

    if (ctaObject.link2 && ctaObject.link2.internal.type === 'ContentfulBlog') {
      setLink2Url(blogBaseUrl + '/' + ctaObject.link2.slug)
    } else if (ctaObject.link2) {
      setLink2Url(buildUrl(ctaObject.link2, ''))
    }
  }, [ctaObject, blogBaseUrl])

  useEffect(() => {
    if (eventApi && eventModelToPublish) {
      publishBrochureButtonInteractionEvent(eventApi, eventModelToPublish)
    }
  }, [eventApi, eventModelToPublish])

  const handleClick = (e) => {
    let linkClasses = e.target.className
    let linkDomain = null
    let linkId = e.target.id
    let linkUrl = null
    let linkText = e.target.textContent

    var linkElement = findParentElementA(e.target, 0, 4)

    if (linkElement !== null) {
      linkUrl = linkElement.href
      linkDomain = extractDomain(linkUrl)
      linkId = linkElement.id
      linkClasses = linkElement.className
    }

    setEventModelToPublish(
      buildBrochureButtonInteractionEvent(linkClasses, linkDomain, linkId, linkUrl, linkText)
    )
  }

  const baseSectionClassName = 'article__item article__intro cta text-dark p-0'
  const sectionClassName = suppressTopMargin
    ? `${baseSectionClassName} suppress-top-margin`
    : baseSectionClassName

  return (
    <section className={sectionClassName}>
      <div className="container">
        <div className="row">
          <div className="cta-container col-15 col-md-10">
            {ctaObject.title ? (
              <h2 className="mt-5">
                <span>{ctaObject.title}</span>
              </h2>
            ) : null}

            <p className="mb-0">{ctaObject.intro ? ctaObject.intro.intro : null}</p>
            <div className="row">
              <div className="col-lg-10 mt-5 d-flex flex-column">
                {ctaObject.url1 ? (
                  <a
                    href={ctaObject.url1}
                    target="_blank"
                    rel="noreferrer"
                    className="btn btn-red btn-long"
                    onClick={handleClick}
                  >
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <span>{ctaObject.text1}</span>
                      <i className="icon-Btn-Arrow"></i>
                    </div>
                  </a>
                ) : null}
                {ctaObject.url2 ? (
                  <a
                    href={ctaObject.url2}
                    target="_blank"
                    rel="noreferrer"
                    className="btn btn-long"
                    onClick={handleClick}
                  >
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <span>{ctaObject.text2}</span>
                      <i className="icon-Btn-Arrow"></i>
                    </div>
                  </a>
                ) : null}
                {link1Url ? (
                  <Link to={link1Url} className="btn btn-red btn-long" onClick={handleClick}>
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <span>{ctaObject.text1}</span>
                      <i className="icon-Btn-Arrow"></i>
                    </div>
                  </Link>
                ) : null}
                {link2Url ? (
                  <Link to={link2Url} className="btn btn-long" onClick={handleClick}>
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <span>{ctaObject.text2}</span>
                      <i className="icon-Btn-Arrow"></i>
                    </div>
                  </Link>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CTA
